//thesis.js
import request from '@/utils/request';

// 提交投稿表单
export function postThesis(data) {
  return request({
    url: '/v1/user_info/manuscript_info',
    method: 'post',
    data: data,
  });
}

// 提交投稿附件
export function postThesisFile(data, params) {
  return request({
    url: '/v1/user_info/manuscript_info/attachment',
    method: 'post',
    data: data,
    params: params,
  });
}

// 获取投稿表单详情
export function getMyThesisDetail(manuscript_id) {
  return request({
    url: '/v1/user_info/manuscript_info/' + manuscript_id,
    method: 'get',
  });
}

// 编辑投稿表单
export function putMyThesisDetail(manuscript_id, data) {
  return request({
    url: '/v1/user_info/manuscript_info/' + manuscript_id,
    method: 'put',
    data: data,
  });
}
